<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <pricing-card icon-color="icon-success">
            <h6 slot="category" class="category"></h6>
            <md-icon slot="icon">home</md-icon>
            <h3 slot="title" class="title"></h3>
            <p slot="description" class="card-description">
              我購買的套餐
            </p>
            <md-button slot="footer" class="md-success md-round"
                href="/dashboard" @click="linkClick"
              >我的套餐</md-button
            >
          </pricing-card>
        </div>

        <div class="md-layout-item md-size-100">
          <pricing-card icon-color="icon-success">
            <h6 slot="category" class="category"></h6>
            <md-icon slot="icon">home</md-icon>
            <h3 slot="title" class="title"></h3>
            <p slot="description" class="card-description">
              門市資訊
            </p>
            <md-button slot="footer" class="md-success md-round"
              href="/stores" @click="linkClick"
              >門市清單</md-button
            >
          </pricing-card>
        </div>

        <div class="md-layout-item md-size-100">
          <pricing-card  card-class="md-card-plain" icon-color="icon-black">
            <h6 slot="category" class="category"></h6>
            <md-icon slot="icon">person</md-icon>
            <h3 slot="title" class="title"></h3>
            <p slot="description" class="card-description">
              個人資料
            </p>
            <md-button slot="footer" class="md-success md-round"
              href="/user-profile" @click="linkClick"
              >個人資料編輯</md-button
            >
          </pricing-card>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import {
  NavTabsCard,
  PricingCard,
  TestimonialCard
} from "@/components";

export default {
  components: {
    PricingCard,
  },
  props: {
    profileCard: {
      type: String,
      default: process.env.VUE_APP_BASE_URL + "/img/faces/card-profile1-square.jpg"
    }
  },
  data() {
    return {
      selected: [],
      responsive: false,
      firstTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: "Lines From Great Russian Literature? Or E-mails From My Boss?"
        },
        {
          tab:
            "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
        }
      ],
      secondTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: "Lines From Great Russian Literature? Or E-mails From My Boss?"
        },
        {
          tab:
            "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
        }
      ],
      thirdTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: "Lines From Great Russian Literature? Or E-mails From My Boss?"
        },
        {
          tab:
            "Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit"
        }
      ],
      users: [
        {
          id: 1,
          name: "Dakota Rice",
          salary: "$36,738",
          country: "Niger"
        },
        {
          id: 2,
          name: "Minerva Hooper",
          salary: "$23,738",
          country: "Curaçao"
        },
        {
          id: 3,
          name: "Sage Rodriguez",
          salary: "$56,142",
          country: "Netherlands"
        },
        {
          id: 4,
          name: "Philip Chaney",
          salary: "$38,735",
          country: "Korea, South"
        }
      ]
    };
  },
  methods: {
    onSelect: function(items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>

<style lang="css"></style>
